import { render, staticRenderFns } from "./template_box.vue?vue&type=template&id=7ce00e1b&scoped=true&"
import script from "./template_box.vue?vue&type=script&lang=js&"
export * from "./template_box.vue?vue&type=script&lang=js&"
import style0 from "./template_box.vue?vue&type=style&index=0&id=7ce00e1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce00e1b",
  null
  
)

export default component.exports